import React from 'react';
import { Link } from '../../visions/vx-link';
import flyerPdf from 'file-loader?name=docs/[name].[ext]!../../../assets/docs/compressedupdatedglobalrecallsflyer.compressed.pdf';

const AboutPortal = (props) => (
	<div className="container main">
		<h2>포털 소개</h2>
		<hr/>
		<div className="row">
			<div className="col-sm-6">
				<iframe width="100%" height="310" src="https://player.vimeo.com/video/170923073" frameBorder="0" allowFullScreen=""/>
			</div>
			<div className="col-sm-6">
				<h4><em>GlobalRecalls</em> 포털이란 무엇입니까?</h4>
				<p>
					<em>GlobalRecalls</em> 포털은 하나의 OECD 플랫폼에서 전 세계적으로 발생한 제품 리콜 관련 정보를 정기적으로 제공합니다.
					포털에는 정부 당국에서 발동하거나 정부 당국에 통지되어 일반에 공개된 강제적 그리고 자발적 소비재 리콜 정보가 있습니다.
					리콜 범위는 정보를 제공하는 특정 정부 당국의 권한에 따라 다릅니다.
					경우에 따라 식품, 차량, 의약품에 대한 리콜이 포함되는 경우도 있습니다.
				</p>
				<p><em>GlobalRecalls</em> 포털은 2012년 10월 19일에 서비스를 시작했습니다.</p>
			</div>
		</div>
		<hr/>
		<div className="row">
			<div className="col-sm-6">
				<h4>포털 이용 대상은 누구입니까?</h4>
				<p>
					<em>GlobalRecalls</em> 포털은 관할 국가들 전체의 정보 공유를 강화하여 규제기관의 시정 조치를 지원합니다.
					자체 전자 제품 리콜 데이터베이스가 있는 모든 관할권은 포털에 기여하도록 요청받습니다.
				</p>
				<p>
					이 포털은 소비자와 기업에도 유용합니다.
					소비자는 구매하려는 제품에 안전 문제가 있는지 이 포털에서 확인할 수 있습니다. 특히 온라인으로 해외 직구매 시 유용합니다.
					또한 기업은 전 세계적으로 발생하는 위험 요소를 더 빠르게 추적하여 자사 제품의 문제를 더 빨리 해결할 수 있습니다.
				</p>
				<p>포털은 자체 온라인 소비재 리콜 데이터베이스가 없는 국가의 규제기관과 소비자 및 기업에 특히 유용한 정보 소스입니다.</p>
			</div>
			<div className="col-sm-6">
				<h4>포털에는 어떤 리콜 정보가 포함됩니까?</h4>
				<p>
					<em>GlobalRecalls</em> 포털에는 현재 전 세계 47개 관할권의 소비재 리콜이 포함되어 있으며 유럽연합 및 ASEAN 지역 리콜 포털이 통합되어 있습니다.
					포털은 참여국의 새로운 데이터와 과거 데이터를 바탕으로 정기적으로 업데이트됩니다.
				</p>
				<p>
					참여하는 관할국마다 "소비재"의 정의에 해당하는 제품 유형이 다소 상이할 수 있습니다.
					예를 들면, 화장품이 소비재 리콜에 포함되는 국가도 있고 차량이 소비재 리콜에 포함되는 국가도 있습니다.
				</p>
			</div>
		</div>
		<hr/>
		<div className="row">
			<div className="col-sm-6">
				<h4>포털은 어떻게 업데이트됩니까?</h4>
				<p>
					포털에 정보를 보내는 빈도와 시기는 각 관할권이 결정하며, 일부 관할권은 자체 시스템에 따라 자동으로 전송하기도 하고 수동으로 전송하기도 합니다.
					업데이트 주기는 일별, 주별 또는 월별 간격으로 다를 수 있습니다.
				</p>
			</div>
			<div className="col-sm-6">
				<h4>포털에서 리콜 정보를 제공하는 기간은 얼마나 됩니까?</h4>
				<p>정보는 각 관할국이 허용하는 동안 저장됩니다. 따라서 일부 정보는 영구적으로 제공될 수도 있습니다.</p>
			</div>
		</div>
		<hr/>
		<div className="row">
			<div className="col-sm-6">
				<h4>리콜 정보가 포털에는 있지만 관련 관할권의 리콜 웹사이트에는 없거나, 그 반대일 수도 있나요?</h4>
				<p>
					포털에서 어떤 정보를 공유할지는 참여하는 각 관할국이 결정합니다.
					따라서 관할 국가의 자국 내 웹사이트에는 특정 리콜에 대한 세부 내용이 실려 있는 경우가 있을 수 있습니다.
				</p>
				<p>그러나 일반적으로 관할 국가는 포털을 통해 모든 리콜 정보를 공개하기 위해 노력합니다.</p>
			</div>
		</div>
	</div>
);

export default AboutPortal;



// WEBPACK FOOTER //
// ./src/views/static/ko/about-portal.js